<script>
  import Ranking from 'src/pc/pages/Ranking'
  import PageLayout from '../layouts/PageLayout'
	import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  export default {
    extends: Ranking,
    components: {
      PageLayout,
      DisplayContainer,
    }
  }
</script>

<style>
  .ranking {
    top: 0 !important;
  }
  .ranking .display-container.title {
    width: 100vw;
    margin-bottom: 30px;
  }
  .ranking .title_top {
    width: 100vw;
    height: 100px;
    padding: 20px;
    justify-content: center;
  }
  .ranking .title_top:before {
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }
  .ranking .title_top p {
    font-size: 34px;
  }
  .ranking .container {
    display: block;
    width: 100%;
  }
  .ranking .container {
    margin-bottom: 40px;
  }
  .ranking .container:nth-child(odd) {
    margin-right: 0;
  }
  .ranking .container h3 {
    font-size: 20px;
    margin-top: 15px;
    margin-bottom: 15px;
    text-align: center;
    line-height: 1.0em;
  }
  .ranking .container h3 i {
    display: block;
    font-size: 15px;
    margin-left: 0;
    margin-top: 5px;
  }
  .ranking .ranktable {
    font-size: 13px;
    font-weight: 700;
    min-width: 100%;
    white-space: pre-line;
    overflow-x: scroll;
    display: block;
  }
  .ranking .ranktable tbody {
    display: table;
    width: 100%;
  }
  .ranking .ranktable tr {
    height: 50px;
  }
  .ranking .ranktable th {
    font-weight: 800;
  }
  .ranking .ranktable th,
  .ranking .ranktable td {
    padding: 0 5px;
  }
  .ranking .ranktable th:first-child,
  .ranking .ranktable td:first-child {
    padding-left: 10px;
  }
  .ranking .ranktable th:last-child,
  .ranking .ranktable td:last-child {
    /*padding-right: 20px;*/
  }
  .ranking .ranktable td .flag {
    width: 20px;
  }
  .ranking .btm_txt {
    margin-top: 60px;
  }
  .ranking .btm_txt li {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.4em;
    margin: 5px 0;
  }
  .ranking .ad_wrap.mid {
    padding: 0;
  }
</style>
